<template>
  <div class="mobile-money has-text-left">

    <!-- Content -->
    <div class="row">
      <div class="col-12 col-md-7">
        <div class="rounded background-light-gray border border-dark-gray p-3">
          <form @submit.prevent="submit">
            <p class="font-weight-bold">Select A Payment Method</p>
            <div class="mb-3">
              <b-skeleton-wrapper :loading="!accountPaymentMethods.length">
                <template #loading>
                  <p>
                    <b-skeleton></b-skeleton>
                    <b-skeleton width="25%"></b-skeleton>
                    <b-skeleton></b-skeleton>
                  </p>
                </template>
                <b-form-group label="" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="selected"
                    :options="processedPaymentMethods"
                    :aria-describedby="ariaDescribedby"
                    name="radios-stacked"
                    stacked
                  ></b-form-radio-group>
                </b-form-group>
              </b-skeleton-wrapper>

              <!-- <h3 class="mt-0">
                (Wallet Balance: <span class="text-primary">{{ vendorStats.wallet_balance }} {{ vendorStats.currency }}</span>)
              </h3> -->
            </div>

            <!-- <button v-if="loading" disabled="" variant="success" class="px-5 mt-4">Please wait <b-spinner small></b-spinner></button> -->
            <b-button xv-if="!loading" variant="success" type="submit" class="px-5 py-1 mt-4 rounded-pill" :disabled="!selected">Next</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TransactionAPI from '../api/transactions_api';
import store from '../store';

export default {
  data() {
    return {
      selected: '',
      transaction_amount: null,
      loading: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var self = this,
        id = this.$route.params.id ? this.$route.params.id : 0;

      if (store.state.payVendorState.vendor_account == null && store.state.payVendorState.transaction_amount == null) {
        if (id > 0) {
          this.$router.push({ name: 'Make Payment', params: { id: id} });
        } else {
          this.$router.push({ name: 'Vendors'});
        }
      }

      TransactionAPI.methods.getAccountById(id);
      TransactionAPI.methods.getAccountPaymentMethods();
      TransactionAPI.methods.getVendorDashboardStats();
    },
    submit() {
      this.loading = true;

      store.state.payVendorState.payment_method = this.selected;

      if (store.state.payVendorState.payment_method !== 'wallet') {
        this.$router.push({ name: 'Make Payment Summary' });
      } else {
        this.$router.push({ name: 'Pay with Wallet' });
      }
    },
    getWalletBalance(display_name) {
      if (this.checkBalanceSufficient) {
        return display_name + ' <strong>(Wallet Balance: <span class="text-primary">' + this.vendorStats.wallet_balance + '</span>)</strong>';
      } else {
        return display_name + ' <strong class="text-danger">(Insufficient Wallet Balance)</strong>';
      }
    },
  },
  computed: {
    accountPaymentMethods: {
      get: function () {
        return store.state.accountPaymentMethods;
      },
      set: function (newValue) {
        store.state.accountPaymentMethods = newValue;
      }
    },
    vendorStats: {
      get: function () {
        return store.state.vendorStats;
      },
      set: function (newValue) {
        store.state.vendorStats = newValue;
      }
    },
    processedPaymentMethods() {
      const self = this;
      let paymentMethodsCollection = [];

      this.accountPaymentMethods.map(type => {
        const payment_method = type.payment_method;
        
        paymentMethodsCollection.push({
          html: payment_method.display_name,
          value: payment_method.system_code,
          // disabled: payment_method.system_code == 'wallet' ? !self.checkBalanceSufficient : false
        });
      });

      return paymentMethodsCollection;
    },
    checkBalanceSufficient() {
      let result = this.vendorStats.wallet_balance >= store.state.payVendorState.transaction_amount ? true : false;
      
      return result;
    }
  }
};
</script>
<style scoped>
.section .title-divider {
  margin: auto;
  width: 100px;
  height: 5px;
  background: #00a27f;
}
.light-subtitle {
  font-size: 1.5rem;
  padding: 2% 10% 2% 10%;
  margin-bottom: 0 !important;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.text-big {
  font-size: 3em;
}
.text-blue {
  color: #0085ba;
}
.background-light-gray {
  background: #f2f2f2;
}
.border-dark-gray {
  border-color: #d9d9d9 !important;
}
.red {
  color: red;
}
.green { 
  color: green;
}
.b-skeleton-wrapper {
  width: 90%;
}
.reflect-rotate {
  transform: rotate(275deg) scaleX(-1);
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
@media (max-width: 768px) {
  .rounded-pill {
    border-radius: 5px !important;
  }
}
</style>
